<footer class="auth-footer">
  <div class="container">
    <span class="rights-text">{{ "common.dictionary.copyright_notice" | translate }}</span>
    <app-footer-info-links />
  </div>
</footer>
